import React, { Component } from 'react';

import './style.sass';
import CommonUsualText from '../../../common-components/common-usual-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Development extends Component {
    render() {
        return (
            <div className="gapresource-development">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <div className="gapresource-development__inner">
                        <CommonUsualText className="gapresource-development__text">
                            Для клиента, помимо технической стороны, было важно качественно
                            интегрировать большое количество медиафайлов (видеоролики, баннеры,
                            динамичные фото), которые должны одинаково отображаться и загружаться на
                            десктопе, планшете и в мобайле. Этот вопрос проработали с дизайнерами и
                            разработчиками — решили разделить и вывести дополнительные поля для
                            различных устройств, дополнительно адаптировать файлы для различных
                            версий.
                        </CommonUsualText>
                        <CommonUsualText className="gapresource-development__text">
                            После окончания технических работ протестировали сайт вместе с
                            заказчиком, чтобы выявить неточности и оперативно их исправить. И после
                            переноса сайта на основной хостинг снова протестировали. Техническая
                            поддержка остается на стороне нашего агентства. Следующий этап —
                            развитие языковых версий сайта и запуск турецкой версии.
                        </CommonUsualText>
                    </div>
                </ScrollAnimation>
            </div>
        );
    }
}

export default Development;
